<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2">For the Tulsa gang—</p>
<p class="ded1">Joy and Mike Bruza,</p>
<p class="ded1-1">Caroline and Emily</p>
<p class="ded1">Janythe and Tim Graham</p>
<p class="ded1-1">Lauren and Scott</p>
<p class="ded1">Jennifer Carwile</p>
<p class="ded1-1">Meredith and Matt</p>
<p class="ded1">And in memory of Jack and Tony Bruza</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SinsofSummer_dedi-1.vue?c32bc562